import React from 'react'
import PropTypes from 'prop-types'
import { ContractShape, ContractVehicleShape } from './prop_shapes/PropShapes'
import { sortBy } from 'lodash-es'

const ContractDropdown = (props) => {
  const {
    selectedContract,
    selectedContractVehicle,
    notListed,
    freeformContract,
    handleFreeformContract,
    handleNotListedClick,
    handleAddContractClick,
    handleUnselectContract
  } = props

  const placeholderText = 'Select a Contract'

  const contractName = (contract) => {
    return contract.expired ? `${contract.name} (expired)` : contract.name
  }

  const contractsList = () => {
    const list = sortBy(selectedContractVehicle?.contracts, 'name').map(c =>
      <li key={c.id} onClick={() => handleAddContractClick(c)}>{contractName(c)}</li>
    )
    const unselectOption = <li key={0} onClick={() => handleUnselectContract()}>{placeholderText}</li>
    return (
      <ul>
        {unselectOption}
        {list}
      </ul>
    )
  }

  const contractNotListedOption = () => {
    return <div onClick={handleNotListedClick} className='not-listed-option'><i className='fa-solid fa-do-not-enter' />I don't see my contract</div>
  }

  const renderContractSelect = () => {
    const selectText = selectedContract ? contractName(selectedContract) : placeholderText
    const labelText = 'Contract'
    const disabled = !selectedContractVehicle

    if (notListed || freeformContract?.length > 0) {
      return (
        <div className='select-dropdown-container'>
          <label className='dropdown-label'>{labelText}</label>
          <input placeholder='Please enter contract name' onChange={handleFreeformContract} className='not-listed-input' value={freeformContract} />
        </div>
      )
    } else {
      return (
        <div className='select-dropdown-container'>
          <label className='dropdown-label'>{labelText}</label>
          <button type='button' data-toggle='contract-dropdown' disabled={disabled} className='dropdown-button'>{selectText}<i className='fa-solid fa-sort disabled dropdown-icon' /></button>
          <div id='contract-dropdown' className='dropdown-pane has-position-bottom select-dropdowns' data-dropdown data-close-on-click>
            {contractsList()}
            {contractNotListedOption()}
          </div>
        </div>
      )
    }
  }

  return renderContractSelect()
}

ContractDropdown.propTypes = {
  selectedContract: ContractShape,
  selectedContractVehicle: ContractVehicleShape,
  notListed: PropTypes.bool.isRequired,
  freeformContract: PropTypes.string,
  handleFreeformContract: PropTypes.func.isRequired,
  handleNotListedClick: PropTypes.func.isRequired,
  handleAddContractClick: PropTypes.func.isRequired,
  handleUnselectContract: PropTypes.func.isRequired
}

ContractDropdown.defaultProps = {
  selectedContract: null,
  selectedContractVehicle: null,
  notListed: false,
  freeformContract: null
}

export default ContractDropdown
